import { render, staticRenderFns } from "./IntervencionActiva.vue?vue&type=template&id=7ec60974"
import script from "./IntervencionActiva.vue?vue&type=script&lang=js"
export * from "./IntervencionActiva.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports